import * as React from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { MoreVert } from "@mui/icons-material";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import ViewWeekIcon from "@mui/icons-material/ViewWeek";
import { useLanguage } from "../../Language";
import { IconButton, ListItemIcon, ListItemText } from "@mui/material";
import { ResourceDWR } from "../../../dto/ResourceDWR";
import { useLocationConfiguration } from "../../LocationConfiguration";
import { useAddToListDialog } from "../search/ls/AddToListDialog";

interface MoreMenuProps {
  resource: ResourceDWR;
  onClickVirtualShelf: () => void;
}
export default function MoreMenu({
  resource,
  onClickVirtualShelf,
}: MoreMenuProps) {
  const { translate } = useLanguage();
  const { locationConfiguration } = useLocationConfiguration();
  const { showDialog } = useAddToListDialog();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const displayVirtualShelf =
    locationConfiguration?.pacSettings?.displaySettings?.displayVirtualShelf;
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  if (!displayVirtualShelf) {
    return (
      <IconButton onClick={() => showDialog([resource.id])} color="primary">
        <PlaylistAddIcon />
      </IconButton>
    );
  }

  return (
    <div>
      <Button
        id="resource-more-button"
        aria-controls={open ? "resource-more-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        variant="outlined"
        color="primary"
      >
        <MoreVert />
      </Button>
      <Menu
        id="resource-more-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{
          list: {
            "aria-labelledby": "resource-more-button",
          },
        }}
      >
        <MenuItem
          onClick={(event) => {
            showDialog([resource.id]);
            handleClose();
          }}
        >
          <ListItemIcon>
            <PlaylistAddIcon />
          </ListItemIcon>
          <ListItemText>{translate("addToList")}</ListItemText>
        </MenuItem>
        <MenuItem
          onClick={() => {
            onClickVirtualShelf();
            handleClose();
          }}
        >
          <ListItemIcon>
            <ViewWeekIcon />
          </ListItemIcon>
          <ListItemText>{translate("virtualShelfButtonText")}</ListItemText>
        </MenuItem>
      </Menu>
    </div>
  );
}
